import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Menu from '../../../components/shared/Menu';
import './style.css';

class UserMenu extends Component {
  static propTypes = {
    className: PropTypes.string
  };
  static defaultProps = {
    className: ''
  };
  handleClear = () => {
    window.localStorage.removeItem('active-user-id');
    window.localStorage.removeItem('clientId');
    setTimeout(() => {
      window.location.href = '/dashboard';
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }, 500);
  };

  renderButton = () => {
    return <i className="fas fa-user-circle app-toolbar-badge-icon" title="" />;
  };
  render() {
    return (
      <Menu component={this.renderButton()} position="center" disabled={true}>
        <div className="user-menu-title">Admin Menu</div>
        <div className="user-menu-options">
          <div className="user-menu-option">Impersonate user</div>
        </div>
      </Menu>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(UserMenu);
